module.exports = "<p>\r\n  acordeon-container works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/acordeon/acordeon-container/acordeon-container.component.html
// module id = ../../../../../src/app/components/common/acordeon/acordeon-container/acordeon-container.component.html
// module chunks = 0